
<ng-container *ngIf="cardForm">
	<div class="credit-card-form-root">
	<form class="credit-card-form-layout cc-form-compact" [formGroup]="cardForm" autocomplete="off">
		<mat-slide-toggle class="save-to-profile-toggle" [color]="accent" formControlName="savetoprofile" (change)="singleFormSet($event)"> Save To Profile </mat-slide-toggle>

		<ng-container *ngIf="effectiveTokenizerIframeUrl">
			<div class="cc-shipto-above-tokenizer" *ngIf="!hideShipTo">
				<mat-form-field class="full-width cc-field-tight" appearance="outline" color="accent" required>
					<mat-label>Ship To</mat-label>
					<mat-select formControlName="branchcode" required>
						<mat-option *ngFor="let branch of branches" [value]="branch.branchcode">
							{{branch.branchcode}}: {{ branch.brname }} - {{ branch.braddress1 }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>

			<div class="tokenizer-panel">
				<div class="tokenizer-panel-heading">Secure card entry</div>
				<div class="tokenizer-panel-body">
					<p class="tokenizer-panel-lead">Enter card number, expiration, and CVV in the fields below.</p>
					<div class="tokenizer-frame-wrap">
						<app-iframe-view [type]="true" [src]="tokenizerIframeSrcForView"></app-iframe-view>
					</div>
				</div>
			</div>

			<div class="cc-cardname-after-tokenizer">
				<mat-form-field class="full-width cc-field-tight" appearance="outline" color="accent" required>
					<mat-label>Card name</mat-label>
					<input matInput type="text" formControlName="name" autocomplete="cc-name" required>
				</mat-form-field>
			</div>
		</ng-container>

		<ng-container *ngIf="!effectiveTokenizerIframeUrl && !hideShipTo">
			<mat-form-field class="full-width cc-field-tight cc-shipto-field" appearance="outline" color="accent" required>
				<mat-label>Ship To</mat-label>
				<mat-select formControlName="branchcode" required>
					<mat-option *ngFor="let branch of branches" [value]="branch.branchcode">
						{{branch.branchcode}}: {{ branch.brname }} - {{ branch.braddress1 }}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</ng-container>

		<ng-container *ngIf="!effectiveTokenizerIframeUrl && useStripe">
			<mat-form-field class="full-width cc-field-tight" appearance="outline" color="accent" required>
				<mat-label>Card Name</mat-label>
				<input matInput type="text" formControlName="name" autocomplete="cc-name" required>
			</mat-form-field>
			<div class="full-width stripe-card-container" #stripeCardContainer></div>
		</ng-container>
		<ng-container *ngIf="!effectiveTokenizerIframeUrl && !stripeGatewayActive">
			<!-- Custom inputs (no Angular Material) — cc* directives still handle format/validation -->
			<label class="ccf-field">
				<span class="ccf-label">Card Name</span>
				<input class="ccf-input" type="text" formControlName="name" autocomplete="cc-name" placeholder="Name on card">
			</label>
			<label class="ccf-field">
				<span class="ccf-label">Card Number</span>
				<span class="ccf-input-wrap">
					<input class="ccf-input" type="tel" ccNumber #ccNumber="ccNumber" formControlName="ccnumber" #ccnumber autocomplete="cc-number" placeholder="0000 0000 0000 0000" inputmode="numeric">
					<i class="ccf-scheme fa fa-cc-{{ccNumber.resolvedScheme$ | async}}" *ngIf="ccnumber.value != ''"></i>
				</span>
			</label>
			<div class="ccf-row">
				<label class="ccf-field">
					<span class="ccf-label">Expiration</span>
					<input class="ccf-input" id="cc-exp-date" type="tel" autocomplete="cc-exp" formControlName="expiry" ccExp placeholder="MM/YY" inputmode="numeric">
				</label>
				<label class="ccf-field">
					<span class="ccf-label">CVV</span>
					<input class="ccf-input" id="cc-cvc" type="tel" autocomplete="cc-csc" formControlName="cvv" ccCVC placeholder="CVV" inputmode="numeric">
				</label>
			</div>
		</ng-container>
		<ng-container *ngIf="!effectiveTokenizerIframeUrl && stripeUnconfigured">
			<p class="text-warning small">Stripe is enabled but publishable key is missing from API adapter config. Card entry is blocked until this is set.</p>
		</ng-container>
	</form>
	<ng-container *ngIf="type == 'orderentry'">
		<button type="button" class="btn btn-sm btn-primary cc-add-card-btn" [disabled]="useStripe ? (!stripeMounted || !cardForm.get('name')?.value) : !cardForm.valid" (click)="addPaymentMethod($event)" *ngIf="!sending"> Add Credit Card</button>
		<span *ngIf="sending"><svg class="spinner" width="35px" height="35px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
				<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
			</svg>
		</span>
	</ng-container>
	</div>
</ng-container>
